import { render, staticRenderFns } from "./SupplyTgRightDetail.vue?vue&type=template&id=dc8e5a48&scoped=true"
import script from "./SupplyTgRightDetail.vue?vue&type=script&lang=js"
export * from "./SupplyTgRightDetail.vue?vue&type=script&lang=js"
import style0 from "./SupplyTgRightDetail.vue?vue&type=style&index=0&id=dc8e5a48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8e5a48",
  null
  
)

export default component.exports